import React from 'react';
import { UNITED_STATES } from '../../../../constants/UnitedStates';
import { useTranslation } from '../../../../i18n/translate/useTranslation';
import { AutoSuggestField } from '../../../../components/auto-suggest/AutoSuggestField';
import { getStateAbbreviationForName } from '../../../../utils/getStateAbbreviationForName';

const US_STATE_DROPDOWN_ITEMS = UNITED_STATES.map((state) => state.name);

export const State = () => {
	const { t } = useTranslation();

	return (
		<AutoSuggestField
			name="state"
			label={t('parking_details_form_state_label')}
			placeholder={t('parking_details_form_state_placeholder')}
			items={US_STATE_DROPDOWN_ITEMS}
			filter={filterStateDropdownItems}
		/>
	);
};

function filterStateDropdownItems(name: string, inputValue?: string) {
	if (!inputValue) {
		return true;
	}

	const inputValueLowerCase = inputValue.toLowerCase();

	if (name.toLowerCase().startsWith(inputValueLowerCase)) {
		return true;
	}

	const abbreviation = getStateAbbreviationForName(name);

	return abbreviation?.toLowerCase().startsWith(inputValueLowerCase) ?? false;
}
